import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import { referenceOperations } from "../../../modules/definition/references";
import { typeOperations } from "../../../modules/definition/types";
// import ImmutablePropTypes from "react-immutable-proptypes";
import { PropTypeShapes } from "../../../types";
import SettingsReferenceDetailView from "./SettingsReferenceDetailView";

const listItems = props => {
  return props.references.allIds
    .map(pId => {
      const p = props.references.byId.get(pId);
      const label = p.label + (p.showInverse && p.inverseLabel !== p.label ? ` / ${p.inverseLabel}` : "");
      return {
        label: label,
        value: p.id,
        color: null,
        icon: null,
        canDelete: p.canDelete
      };
    })
    .toArray();
};

class SettingsReferencesTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <ModalMasterDetailView
        items={listItems(this.props)}
        onItemSelect={this.selectItem}
        onAddClick={this.props.onAddReference}
        onDeleteClick={this.props.onRemoveReference}
        allowDrag={true}
        onMoveItemAtIndex={this.props.onMoveReference}
        backText="References"
        itemsUseIndexAsId={false}
        //#!if iOS === true
// onDoneClick={this.props.onDoneClick}
        //#!endif
      >
        <SettingsReferenceDetailView {...this.props} />
      </ModalMasterDetailView>
    );
  }
}

SettingsReferencesTab.propTypes = {
  references: PropTypeShapes.denormalisedReferenceDefinitionsIdList.isRequired,
  types: PropTypeShapes.denormalisedTypeDefinitionsIdList.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onIconChange: PropTypes.func.isRequired,
  onColorChange: PropTypes.func.isRequired,
  onLineStyleChange: PropTypes.func.isRequired,
  onBidirectionalChange: PropTypes.func.isRequired,
  onShowInverseChange: PropTypes.func.isRequired,
  onInverseLabelChange: PropTypes.func.isRequired,
  onAllowsTypeChange: PropTypes.func.isRequired,
  onIncludeInTypeChange: PropTypes.func.isRequired,
  onAddReference: PropTypes.func.isRequired,
  onMoveReference: PropTypes.func.isRequired,
  onRemoveReference: PropTypes.func.isRequired,
  onEnabledChange: PropTypes.func.isRequired,
  onShowInInspectorChange: PropTypes.func.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired
  //#!endif
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onIconChange: (referenceId, icon) => {
      props.dispatchLocal(referenceOperations.changeIcon(referenceId, icon));
    },
    onColorChange: (referenceId, color) => {
      props.dispatchLocal(referenceOperations.changeColor(referenceId, color));
    },
    onLineStyleChange: (referenceId, lineStyle) => {
      props.dispatchLocal(referenceOperations.changeLineStyle(referenceId, lineStyle));
    },
    onLabelChange: (referenceId, label) => {
      props.dispatchLocal(referenceOperations.changeLabel(referenceId, label));
    },
    onBidirectionalChange: (referenceId, bidirectional) => {
      props.dispatchLocal(referenceOperations.changeBidirectional(referenceId, bidirectional));
    },
    onShowInverseChange: (referenceId, showInverse) => {
      props.dispatchLocal(referenceOperations.changeShowInverse(referenceId, showInverse));
    },
    onInverseLabelChange: (referenceId, label) => {
      props.dispatchLocal(referenceOperations.changeInverseLabel(referenceId, label));
    },
    onIncludeInTypeChange: (typeId, referenceId, isIncluded) => {
      props.dispatchLocal(typeOperations.changeHasReference(typeId, referenceId, isIncluded));
    },
    onAllowsTypeChange: (referenceId, typeId, isIncluded) => {
      props.dispatchLocal(referenceOperations.changeHasType(referenceId, typeId, isIncluded));
    },
    onAddReference: () => {
      props.dispatchLocal(referenceOperations.createReference());
    },
    onMoveReference: (fromIndex, toIndex) => {
      props.dispatchLocal(referenceOperations.moveReference(fromIndex, toIndex));
    },
    onRemoveReference: referenceId => {
      props.dispatchLocal(referenceOperations.deleteReference(referenceId));
    },
    onEnabledChange: (referenceId, enabled) => {
      props.dispatchLocal(referenceOperations.changeEnabled(referenceId, enabled));
    },
    onShowInInspectorChange: (referenceId, showInInspector) => {
      props.dispatchLocal(referenceOperations.changeShowInInspector(referenceId, showInInspector));
    }
  };
};

export default connect(null, mapDispatchToProps)(SettingsReferencesTab);
